module.exports = __webpack_public_path__ + "img/20200507_135813.088bab97.jpg";